module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id=\'table\'></div>\n<div id=\'widgets\' class=\'below-table\'></div>\n';

}
return __p
}